/*
 *   全局过滤器!
 * */
export default {
  install: Vue => {
    Vue.filter("limitDate", val => {
      if (val) {
        return val.substr(0, 10);
      }
    });

    Vue.filter("changeTime", time => {
      if (!time || time.length <= 0) {
        return time;
      }
      if (typeof time == "string") {
        time = new Date(time);
      }
      var y = time.getFullYear(),
        m = time.getMonth() + 1,
        d = time.getDate();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      return y + "-" + m + "-" + d;
    });

    Vue.filter("deepTime", time => {
      time = new Date(time);
      if (!time || time.length <= 0) {
        return time;
      }
      if (typeof time == "string") {
        time = new Date(time);
      }
      var y = time.getFullYear(),
        M = time.getMonth() + 1,
        d = time.getDate(),
        h = time.getHours(),
        m = time.getMinutes(),
        s = time.getSeconds();

      if (M < 10) {
        M = "0" + M;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (m < 10) {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }

      return y + "-" + M + "-" + d + " " + h + ":" + m + ":" + s;
    });
  }
};
